import { BrowserRouter } from 'react-router-dom';
import { Layout, message } from 'antd';

import { Routes } from 'routes';

import { Menu, Processes, RICEInfo } from './components';
import { Auth0ProviderWithRedirectCallback } from './providers';

const { Content } = Layout;

message.config({
  top: 100,
  maxCount: 1,
});

export const CoreLayout = () => (
  <BrowserRouter>
    <Auth0ProviderWithRedirectCallback>
      <Processes />

      <RICEInfo />

      <Layout className='bg-white'>
        <Menu />

        <Content>
          <Routes />
        </Content>
      </Layout>
    </Auth0ProviderWithRedirectCallback>
  </BrowserRouter>
);
